const Band = {
  symbol: 'band',
  color: '#000',
  colorIcon() {
    return `<g fill="none"><circle fill="#516AFF" cx="16" cy="16" r="16"/><g fill="#FFF"><path d="M18.286 12.479l2.2 1.257V7.45l-4.4-2.2L9.25 9.1v13.671l6.836 3.929 6.757-4.007v-6.757l-6.522-3.929-2.2 1.1 6.522 3.85.078 4.636-4.635 2.593-4.715-2.672V10.2l4.715-2.593 2.2 1.179v3.693z"/><path d="M15.85 16.25l1.493-.786 1.65 1.022-4.872 2.75v-5.657L15.85 14.6"/></g></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm.086 5.25L9.25 9.1v13.671l6.836 3.929 6.757-4.007v-6.757l-6.522-3.929-2.2 1.1 6.522 3.85.078 4.636-4.635 2.593-4.715-2.672V10.2l4.715-2.593 2.2 1.179v3.693l2.2 1.257V7.45l-4.4-2.2zm-1.965 8.329v5.657l4.872-2.75-1.65-1.022-1.493.786V14.6l-1.729-1.021z"/>`;
  }
};
export default Band;
